import { render, staticRenderFns } from "./EraseIconButton.vue?vue&type=template&id=041f625c&scoped=true"
import script from "./EraseIconButton.vue?vue&type=script&lang=js"
export * from "./EraseIconButton.vue?vue&type=script&lang=js"
import style0 from "./EraseIconButton.vue?vue&type=style&index=0&id=041f625c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041f625c",
  null
  
)

export default component.exports